import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class SpinnerService {
  
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private settingMessage = new BehaviorSubject<string>('Cargando...');

    isLoading$ = this.loadingSubject.asObservable();
    mensaje$ = this.settingMessage.asObservable();

    show(){
        this.loadingSubject.next(true);
    }
    hide(){
        this.loadingSubject.next(false);
    }

    setMensaje(mensaje){
        this.settingMessage.next(mensaje);
    }
}